export const MOCK_API_ROOT = 'https://msw-mock-auth.api';
